import React from 'react'
import styles from './Textarea.module.scss'
import cl from 'classnames'
import { TextareaProps } from './Textarea.types'

const TextareaComponent = (props: TextareaProps) => {
  const {
    className,
    onChange,
    ...rest
  } = props

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!onChange) return
    onChange(event.target.value)
  }

  return (
    <textarea
      className={cl(styles.textarea, styles.scrollable, className)}
      onChange={handleChange}
      {...rest}
    />
  )
}

const Textarea = TextareaComponent
export { Textarea }
